/**
 * Transfer Incoming Fragment
 * Handles:
 * - List date filter interactions
 * - Download all functionality
 * - Forward file selection toggle
 */

import { Events } from '../../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Transfer List Filter Handlers
// ============================================================================

const TransferListFilter = {
    /**
     * Toggle all incoming transfer checkboxes
     */
    onToggleAllIncoming(e, element) {
        const checked = element.checked;
        const checkboxes = document.querySelectorAll('.incoming-checkbox');
        checkboxes.forEach(cb => {
            cb.checked = checked;
        });
    },

    /**
     * Handle bulk delete of selected incoming transfers
     */
    onBulkDelete(e, element) {
        const checkboxes = document.querySelectorAll('.incoming-checkbox:checked');
        if (checkboxes.length === 0) {
            alert('Please select transfers to delete');
            return;
        }

        if (!confirm('Delete ' + checkboxes.length + ' selected transfer(s)?')) {
            return;
        }

        // Create temporary form with selected receiver OIDs
        const tempForm = document.createElement('form');
        tempForm.style.display = 'none';
        checkboxes.forEach(cb => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'receiver_oids';
            input.value = cb.value;
            tempForm.appendChild(input);
        });
        document.body.appendChild(tempForm);

        // The refresh re-runs the list handler, which reads its state from the query string.
        const filters = document.getElementById('incoming-transfers-filters');
        const params = new URLSearchParams(filters ? new FormData(filters) : undefined);
        // Back to the first page: the deleted rows were on this one, and a preserved
        // offset can land past the end of a list that just got shorter.
        params.set('start', '0');

        htmx.ajax('POST', '/app/transfers/incoming/delete?' + params.toString(), {
            source: tempForm,
            target: '#incoming-transfers',
            swap: 'outerHTML'
        }).then(() => {
            document.body.removeChild(tempForm);
        });
    },

    /**
     * Handle pagination - go to specific page offset
     */
    onGotoPage(e, element) {
        const offset = element.dataset.offset;
        const container = element.closest('#incoming-transfers');
        if (!container) return;

        const form = container.querySelector('form');
        const startInput = container.querySelector('#pagination-start');
        if (form && startInput) {
            startInput.value = offset;
            form.requestSubmit();
        }
    }
};

// ============================================================================
// Transfer Incoming Detail Handlers
// ============================================================================

const TransferIncomingDetail = {
    /**
     * Handle download all files as ZIP
     * Uses direct link navigation for streaming downloads to avoid browser memory issues
     */
    handleDownloadAll(e, element) {
        // Prevent any default behavior (e.g., form submission)
        e.preventDefault();
        e.stopPropagation();

        const receiverOid = element.dataset.receiverOid;
        const transferStatus = element.dataset.transferStatus;

        // Check if transfer is expired or canceled
        if (transferStatus === 'Expired' || transferStatus === 'Canceled') {
            alert('This transfer is no longer available and files cannot be downloaded.');
            return;
        }

        // Build download URL
        const url = `/app/transfers/incoming/transfer/${receiverOid}/download-all`;

        // Use direct link navigation for streaming download
        // This allows the browser to stream directly to disk without buffering in memory
        const a = document.createElement('a');
        a.href = url;
        a.download = '';  // Browser will use Content-Disposition filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
};

// ============================================================================
// Transfer Forward Handlers
// ============================================================================

const TransferForward = {
    /**
     * Toggle all file checkboxes
     */
    onToggleAllFiles(e, element) {
        const checked = element.checked;
        const fileCheckboxes = document.querySelectorAll('.file-checkbox');
        fileCheckboxes.forEach(checkbox => {
            checkbox.checked = checked;
        });
    }
};

// Make available globally for backward compatibility
window.TransferListFilter = TransferListFilter;
window.TransferForward = TransferForward;

// ============================================================================
// Initialization
// ============================================================================

export function initTransferIncoming() {
    if (initialized) return;
    initialized = true;

    // Select all incoming transfers checkbox
    Events.on('change', 'transfer-incoming-select-all', (e, element) => {
        TransferListFilter.onToggleAllIncoming(e, element);
    });

    // Bulk delete button
    Events.on('click', 'transfer-incoming-bulk-delete', (e, element) => {
        TransferListFilter.onBulkDelete(e, element);
    });

    // Pagination buttons
    Events.on('click', 'transfer-incoming-goto-page', (e, element) => {
        TransferListFilter.onGotoPage(e, element);
    });

    // Download all button
    Events.on('click', 'transfer-incoming-download-all', (e, element) => {
        TransferIncomingDetail.handleDownloadAll(e, element);
    });

    // Forward file toggle all
    Events.on('change', 'transfer-forward-toggle-all', (e, element) => {
        TransferForward.onToggleAllFiles(e, element);
    });

    console.log('[LeapFILE] Transfer incoming fragment initialized');
}
